import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/SjMediaHome.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/report',
      name: 'report',
      component: () => import('./views/Report.vue')
    },
    {
      path: '/report/:campaignId',
      name: 'tableReport',
      component: () => import('./views/TableReport.vue')
    },
    {
      path: '/customers',
      name: 'customers',
      component: () => import('./views/customer/List.vue')
    },
    {
      path: '/customers/new',
      name: 'newCustomer',
      component: () => import('./views/customer/New.vue')
    },
    {
      path: '/customers/:id',
      name: 'viewCustomer',
      component: () => import('./views/customer/View.vue')
    }
  ]
})
